import { PropsWithChildren, useState, useMemo, useCallback } from 'react';
import { SubSidebarContext } from './useSubSidebar';

export function SubSidebarProvider({
  children,
  initialOpen = false,
  initialExpanded = true,
}: PropsWithChildren<{
  initialOpen?: boolean;
  initialExpanded?: boolean;
}>) {
  const [isOpen, setIsOpen] = useState(initialOpen);
  const [isExpanded, setIsExpanded] = useState(initialExpanded);
  const [currentPath, setCurrentPath] = useState('');

  const openSubSidebar = useCallback(() => setIsOpen(true), []);
  const closeSubSidebar = useCallback(() => setIsOpen(false), []);
  const toggleSubSidebar = useCallback(() => setIsOpen((prev) => !prev), []);

  const expandSubSidebar = useCallback(() => setIsExpanded(true), []);
  const collapseSubSidebar = useCallback(() => setIsExpanded(false), []);
  const toggleExpandSubSidebar = useCallback(() => setIsExpanded((prev) => !prev), []);

  const value = useMemo(
    () => ({
      isOpen,
      isExpanded,
      currentPath,
      openSubSidebar,
      closeSubSidebar,
      toggleSubSidebar,
      expandSubSidebar,
      collapseSubSidebar,
      toggleExpandSubSidebar,
      setCurrentPath,
    }),
    [
      isOpen,
      isExpanded,
      currentPath,
      openSubSidebar,
      closeSubSidebar,
      toggleSubSidebar,
      expandSubSidebar,
      collapseSubSidebar,
      toggleExpandSubSidebar,
    ],
  );

  return <SubSidebarContext.Provider value={value}>{children}</SubSidebarContext.Provider>;
}
